export const ERROR_CODES = {
    GROUPS_NOT_ADDED_TO_SKILL: 'GroupsNotAddedToSkill',
    CERTIFICATES_NOT_ADDED_TO_SKILL: 'CertificatesNotAddedToSkill',
};
